import React, { ReactNode, useCallback, useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Paper, TextField, Grid, MenuItem } from "@mui/material";
import { Box } from "@mui/system";

import SelectUseForm from "@app/components/organisms/SelectUseForm";

import { useSelector } from "react-redux";
import { RootState } from "@app/config/store";

export type TCollectionForm = {
  name: string;
  languageId: number;
};

type CollectionProps = {
  onValidateSuccess: (data: TCollectionForm) => void;
  footerActions: ReactNode;
  dataForm?: TCollectionForm;
  edit?: boolean;
};

const CollectionForm = ({
  onValidateSuccess,
  footerActions,
  dataForm,
  edit,
}: CollectionProps) => {
  const { currentClasse } = useSelector((state: RootState) => state.classe);
  const { languages } = useSelector((state: RootState) => state.language);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    control,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        name: yup.string().required("Preencha o campo nome"),
        languageId: yup
          .number()
          .typeError("Seleciona um idioma")
          .required("Seleciona um idioma"),
      })
    ),
    defaultValues: {
      name: "",
      languageId: currentClasse?.language.id ?? NaN,
    },
    mode: "onSubmit",
  });

  const onSubmit = useCallback(
    (data: TCollectionForm) => {
      onValidateSuccess(data);
    },
    [onValidateSuccess]
  );

  useEffect(() => {
    reset(dataForm);
  }, [dataForm, reset]);

  return (
    <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <TextField
              id="name"
              type="text"
              fullWidth
              margin="normal"
              variant="outlined"
              label="Nome"
              InputLabelProps={{ shrink: true }}
              error={!!errors.name}
              helperText={!!errors.name && errors.name.message}
              {...register("name")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SelectUseForm
              error={!!errors.languageId}
              helperText={errors.languageId?.message}
              control={control}
              label="Idioma da coleção"
              defaultValue={String(getValues("languageId"))}
              {...register("languageId")}
            >
              {languages.map((language) => (
                <MenuItem value={language.id} key={language.key}>
                  {language.name}
                </MenuItem>
              ))}
            </SelectUseForm>
          </Grid>
        </Grid>
      </Paper>
      <Box sx={{ mt: 10 }}>{footerActions}</Box>
    </form>
  );
};

export default CollectionForm;
